import SectionHeading from '@/components/feature/SectionHeading';
import { testimonials } from '@/mocks/testimonials';

export default function TestimonialSection() {
  const loop = [...testimonials, ...testimonials];

  return (
    <section className="border-b border-background-200 bg-accent-50/60 py-14 md:py-20">
      <div className="mx-auto w-full max-w-content px-4 md:px-6">
        <SectionHeading
          eyebrow="瓜友怎么说"
          title="这些都是读者留下的真实感受"
          desc="我们很少做宣传，瓜友们的留言就是最好的说明。下面的每一句话，都来自订阅邮件和站内反馈。"
          align="center"
        />
      </div>

      <div className="group relative mt-10 overflow-hidden">
        <div className="flex w-max animate-marquee gap-5 group-hover:[animation-play-state:paused]">
          {loop.map((item, i) => (
            <figure
              key={`${item.name}-${i}`}
              className="flex w-[320px] shrink-0 flex-col justify-between rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <div className="flex items-center gap-1 text-secondary-500">
                {Array.from({ length: 5 }).map((_, s) => (
                  <i key={s} className="ri-star-fill text-sm" />
                ))}
              </div>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                {item.text}
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-bold text-primary-700">
                  {item.name.slice(0, 1)}
                </span>
                <span className="leading-tight">
                  <strong className="block text-sm font-medium text-foreground-900">{item.name}</strong>
                  <span className="text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}